export default __webpack_public_path__ + "static/media/no-results-2.fc1dc73a.png";